import ProductTour from "./product-tour";

export default ProductTour;
